module.exports = __webpack_public_path__ + "167181ed22a02b61b37b764689c2827b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-nadine-03.jpg
 ** module id = 364
 ** module chunks = 0
 **/